import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  max-width: 1300px;
  margin: 0 auto;
  flex-direction: column;
  padding: 16px;
  position: relative;
  z-index: 1;

  h1 {
    font-size: 80px;
    color: #fff;
    margin-bottom: 16px;
  }

  span {
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 16px;
  }

  @media (max-width: 1024px) {
    h1 {
      font-size: 60px;
    }

    span {
      font-size: 30px;
    }
  }

  @media (max-width: 767px) {
    h1 {
      font-size: 30px;
    }

    span {
      font-size: 15px;
    }
  }
`;

export const Social = styled.div`
  display: flex;

  a {
    margin: 16px;
    border: 2px solid #fff;
    border-radius: 50%;
    line-height: 0;
    padding: 16px;
    transition: background-color 0.2s;

    &:hover {
      background-color: #fff;
    }

    &:hover .icon-upload {
      fill: #007fff;
    }

    .icon-upload {
      transition: fill 0.2s;
    }
  }
`;

export const Icon = styled.div`
  position: absolute;
  bottom: 40px;
  left: 50;
  animation: pulse 1.6s infinite;

  @keyframes pulse {
    from {
      -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=40)';
      filter: alpha(opacity=40);
      opacity: 0.4;
    }

    50% {
      -ms-filter: none;
      -webkit-filter: none;
      filter: none;
      opacity: 1;
      bottom: 50px;
    }

    to {
      filter: alpha(opacity=40);
      opacity: 0.4;
    }
  }
`;
